import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PageNotFound from '../../../components/Page404';
import HeaderCampaign from '../../../components/Campanhas/CampaignHeader/index';
import Briefing from '../Briefing';
import Thanks from '../Briefing/Thanks';
import utils from '../../../services/utils';

const HomeCampanhas = () => (
	<>
		<HeaderCampaign>Contratar Campanha</HeaderCampaign>
		<div className="col-12" style={{ paddingTop: '3px', margin: '0 auto' }}>
			<Switch>
				<Route path={`${utils.basePath()}/campanhas/nova-campanha/agradecimento`} component={Thanks} exact />
				<Route path={`${utils.basePath()}/campanhas/nova-campanha/:channel?`} component={Briefing} exact />
				<Route key="pageNotFound" path="*" component={PageNotFound} />,
			</Switch>
		</div>
	</>
	);

export default HomeCampanhas;
